import React from 'react';
import { Link } from 'react-router-dom';
import moment from "moment";

const handleValidDate = (date:any) => {
    // Handle different input types to avoid moment.js deprecation warnings
    if (date instanceof Date) {
        // Convert Date to timestamp to avoid deprecation warning
        return moment(date.getTime()).format("DD MMM Y");
    } else if (typeof date === 'number') {
        // Already a timestamp
        return moment(date).format("DD MMM Y");
    } else if (typeof date === 'string') {
        // Try parsing with specific formats to avoid deprecation warnings
        const formats = ['DD MMM Y', 'DD MMM, YYYY', 'YYYY-MM-DD', moment.ISO_8601];
        const parsed = moment(date, formats, true);
        if (parsed.isValid()) {
            return parsed.format("DD MMM Y");
        }
        // If format parsing fails, try ISO format
        const isoParsed = moment(date, moment.ISO_8601, true);
        if (isoParsed.isValid()) {
            return isoParsed.format("DD MMM Y");
        }
        // Last resort: try with new Date
        try {
            return moment(new Date(date).getTime()).format("DD MMM Y");
        } catch {
            return date;
        }
    }
    // Fallback
    try {
        return moment(new Date(date).getTime()).format("DD MMM Y");
    } catch {
        return date;
    }
};

const TicketsId = (cell:any) => {
    return (
        <React.Fragment>
            <Link to="/apps-tickets-details" className="fw-medium link-primary">{cell.getValue()}</Link>
        </React.Fragment>
    );
};

const Title = (cell:any) => {
    return (
        <React.Fragment>
            {cell.getValue()}
        </React.Fragment>
    );
};

const Client = (cell:any) => {
    return (
        <React.Fragment>
            {cell.getValue()}
        </React.Fragment>
    );
};

const AssignedTo = (cell:any) => {
    return (
        <React.Fragment>
            {cell.getValue()}
        </React.Fragment>
    );
};

const CreateDate = (cell:any) => {
    return (
        <React.Fragment>
            {handleValidDate(cell.getValue())}
        </React.Fragment>
    );
};

const DueDate = (cell:any) => {
    return (
        <React.Fragment>
            {cell.getValue()}
        </React.Fragment>
    );
};

const Status = (cell:any) => {
    return (
        <React.Fragment>
            {cell.getValue() === "Inprogress" ? <span className="badge bg-warning-subtle  text-warning text-uppercase">{cell.getValue()}</span>
                : cell.getValue() === "New" ? <span className="badge bg-info-subtle  text-info text-uppercase">{cell.getValue()}</span>
                    : cell.getValue() === "Open" ? <span className="badge bg-success-subtle text-success text-uppercase">{cell.getValue()}</span>
                        : cell.getValue() === "Closed" ? <span className="badge bg-danger-subtle  text-danger text-uppercase">{cell.getValue()}</span>
                            : null
            }
        </React.Fragment>
    );
};

const Priority = (cell:any) => {
    return (
        <React.Fragment>
            {cell.getValue() === "Medium" ?
                <span className="badge bg-warning text-uppercase">{cell.getValue()}</span>
                :
                cell.getValue() === "High" ?
                    <span className="badge bg-danger text-uppercase">{cell.getValue()}</span>
                    : cell.getValue() === "Low" ?
                        <span className="badge bg-success text-uppercase">{cell.getValue()}</span>
                        : null
            }
        </React.Fragment>
    );
};

export { TicketsId, Title, Client, AssignedTo, CreateDate, DueDate, Status, Priority };